import usePatchRequest from '../utils/usePatchRequest';
import { getErrorMessage } from '../../utils/errorCodes';

const usePatch = (path: string) => {
  const { patchData, patchError, patchLoading, executePatch }  = usePatchRequest({
    path: path
  })

  return {
    data: patchData,
    loading: patchLoading,
    // @ts-ignore
    error: getErrorMessage(patchError?.response?.data?.errors && patchError?.response?.data?.errors[0]?.message),
    executePatch
  }
}

export default usePatch;